import type { HotelsLocale } from './en'

export const hotelsFrCa = {
  nav: {
    dashboard: 'Tableau de bord',
    settings: 'Paramètres',
    wakeupScheduling: 'Planification des réveils',
    wakeupHistory: 'Historique des réveils',
  },
  common: {
    unknown: 'Inconnu',
    notAvailable: 'N/D',
    placeholder: '—',
    search: 'Rechercher',
    entries: 'entrées',
    show: 'Afficher',
    retry: 'Réessayer',
    loading: 'Chargement',
    previous: 'Précédent',
    next: 'Suivant',
    dayPlaceholder: 'Jour...',
    timePlaceholder: 'Heure...',
    filterTimesPlaceholder: 'Filtrer les heures...',
  },
  dialogs: {
    confirm: 'Confirmer',
    cancel: 'Annuler',
  },
  errors: {
    loadRooms: 'Échec du chargement des chambres',
    loadWakeupHistory: "Échec du chargement de l'historique des réveils",
    loadPbxSettings: 'Échec du chargement des paramètres PBX',
    loadExtensions: 'Échec du chargement des extensions',
  },
  pagination: {
    previousPage: 'Page précédente',
    nextPage: 'Page suivante',
    resultsPerPage: 'Résultats par page :',
    all: 'Tous',
    jumpToPage: 'Aller à la page {{page}}',
    recordRange: '{{start}}—{{end}} sur {{total}}',
    recordRangeEmpty: '0 sur 0',
  },
  tableToolbar: {
    entriesOnly: '{{count}} entrées',
    entriesFiltered: '{{filtered}} sur {{total}} entrées',
    resultsPerPage: 'Résultats par page :',
    showingSummary: 'Affichage de {{start}} à {{end}} sur {{count}}',
  },
  datePresets: {
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    yesterday: 'Hier',
    '1week': '1 semaine',
    '2weeks': '2 semaines',
    '3weeks': '3 semaines',
    '4weeks': '4 semaines',
    all: 'Tous',
  },
  wakeupStatus: {
    scheduled: 'Planifié',
    tried: 'Tenté',
    cleared: 'Effacé',
    canceled: 'Annulé',
  },
  dashboard: {
    incomingCallHistory: 'Historique des appels entrants',
    emergencyHistory: 'Historique 911 (7 jours)',
    roomStatus: 'État des chambres',
    searchCalls: 'Rechercher des appels...',
    noIncomingCalls: 'Aucun appel entrant',
    noMatchingCalls: 'Aucun appel ne correspond à votre recherche',
    number: 'Numéro',
    name: 'Nom',
    time: 'Heure',
    destination: 'Dest.',
    room: 'Chambre',
    timeAndDate: 'Heure et date',
    duration: 'Durée',
    noEmergencyCalls: 'Aucun appel',
    emergencyFooter: '* Appel passé au {{destination}}',
    refreshingIn: 'Actualisation dans {{seconds}} s',
    noRoomsTitle: 'Aucune chambre trouvée',
    noRoomsDescription:
      "Aucune chambre d'accueil n'est configurée pour ce PBX.",
    resetRoomsSuccess: '{{count}} chambres réinitialisées à Sale',
    resetRoomsFailed: 'Échec de la réinitialisation des chambres',
    roomStatusActions: {
      dirty: 'Sale',
      clean: 'Propre',
      occupied: 'Occupée',
      inspected: 'Inspectée',
    },
    roomTile: {
      openAria: 'Ouvrir la chambre {{room}}',
    },
    roomDetail: {
      title: 'Chambre {{room}}',
      changeStatus: 'Changer le statut',
      cleanOrInspectedWarning:
        'Passer à Propre ou Inspectée annulera les réveils actifs et effacera les messages vocaux.',
      activeWakeups: 'Réveils actifs',
      voicemails: 'Messages vocaux',
      statusUpdated: 'Statut de la chambre mis à jour',
      statusUpdateFailed: 'Échec de la mise à jour du statut de la chambre',
    },
    resetAllRooms: {
      button: 'Réinitialiser toutes les chambres à Sale',
      title: 'Réinitialiser toutes les chambres',
      description:
        "Toutes les chambres passeront à l'état Sale. Les réveils et messages vocaux ne seront pas affectés. Continuer?",
      confirm: 'Tout réinitialiser',
    },
    wakeupPopover: {
      title: 'Réveils',
      manageAria: 'Gérer les réveils',
      manageAriaPending: 'Gérer les réveils (en attente)',
      manageAriaCleared: 'Gérer les réveils (effacés)',
      clearAll: 'Tout effacer?',
      clearAllSuccess: '{{count}} réveil{{suffix}} annulé',
      clearAllFailed: 'Échec de la suppression des réveils',
      scheduleSuccess: 'Réveil planifié',
      scheduleFailed: 'Échec de la planification du réveil',
      addAria: 'Ajouter un réveil',
      loading: 'Chargement...',
      none: 'Aucun réveil actif',
      schedule: 'Planification',
      cancelAria: 'Annuler le réveil',
      cancelAriaWithTime: 'Annuler le réveil de {{time}}',
    },
    voicemailPopover: {
      title: 'Messages vocaux',
      manageAria: 'Gérer les messages vocaux',
      manageAriaWithCount_one:
        'Gérer les messages vocaux ({{count}} message vocal)',
      manageAriaWithCount_other:
        'Gérer les messages vocaux ({{count}} messages vocaux)',
      clearAll: 'Tout effacer?',
      clearAllSuccess_one: '{{count}} message vocal supprimé',
      clearAllSuccess_other: '{{count}} messages vocaux supprimés',
      clearAllFailed: 'Échec de la suppression des messages vocaux',
      loading: 'Chargement...',
      none: 'Aucun message vocal',
      status: 'Statut',
      received: 'Reçu',
      from: 'De',
      read: 'Lu',
      new: 'Nouveau',
      deleteAria: 'Supprimer le message vocal',
      deleteSuccess: 'Message vocal supprimé',
      deleteFailed: 'Échec de la suppression du message vocal',
    },
  },
  wakeupScheduler: {
    scheduleSuccess: '{{count}} réveil{{suffix}} planifié',
    scheduleFailed: 'Échec de la planification des réveils',
    selectDate: 'Sélectionner la date',
    selectTime: "Sélectionner l'heure",
    scheduleWakeupCalls: 'Planifier des réveils',
    scheduling: 'Planification...',
    selectedRooms: '{{count}} chambre{{suffix}} sélectionnée',
    cancelSuccess: 'Réveil annulé',
    cancelFailed: "Échec de l'annulation du réveil",
    addToPendingAria: 'Ajouter aux changements en attente',
    pendingChanges: 'Changements en attente',
    noPendingChanges: 'Aucun changement en attente',
    applyChanges: 'Appliquer les changements',
    reset: 'Réinitialiser',
    noMatchingRooms: 'Aucune chambre correspondante',
    noRoomsAvailable: 'Aucune chambre disponible',
    roomNumber: 'Numéro de chambre',
    roomName: 'Nom de chambre',
    status: 'Statut',
    currentSchedule: 'Horaire actuel',
    selectAllRooms: 'Sélectionner toutes les chambres',
    selectRoom: 'Sélectionner la chambre {{number}}',
    dayLabel: 'Jour',
    timeLabel: 'Heure',
    filterTimesLabel: 'Filtrer les heures',
    removePendingAria:
      'Retirer le réveil en attente pour la chambre {{room}}, {{time}}',
    cancelWakeupAria: 'Annuler le réveil de la chambre {{room}} à {{time}}',
  },
  history: {
    noHistory: 'Aucun historique de réveils',
    noMatchingRecords: 'Aucun enregistrement correspondant',
    showing: 'Affichage de {{start}} à {{end}} sur {{count}} entrées',
    filteredFromTotal: '(filtré sur {{total}} entrées totales)',
    room: 'Chambre',
    roomName: 'Nom de chambre',
    attempts: 'Tentatives',
    wakeupDateTime: 'Date et heure du réveil',
    activationDateTime: "Date et heure d'activation",
    wakeupStatus: 'Statut du réveil',
    originator: 'Originateur',
    originPhone: 'Téléphone',
    originPortal: 'Portail',
  },
  settings: {
    activation: 'Activation',
    searchRoomsOrNames: 'Rechercher par chambre ou nom...',
    noMatchingExtensions: 'Aucune extension ne correspond à votre recherche',
    noExtensionsForPbx: 'Aucune ligne de poste trouvée pour ce PBX',
    active: 'Actif',
    roomNumber: 'Numéro de chambre',
    extensionName: 'Nom du poste',
    currentStatus: 'Statut actuel',
    roomActiveAria: 'Chambre {{number}} active',
    statusAtTime: '{{status}} ({{time}} - {{date}})',
    activated: 'activée',
    deactivated: 'désactivée',
    roomToggleStatus: 'Chambre {{roomNumber}} {{action}}',
    toggleHospitalityFailed: "Échec de l'activation hôtelière",
    resetRoomsToDirty: 'Réinitialiser les chambres à Sale',
    everyDayAt: 'Tous les jours à',
    manually: 'Manuellement',
    saveSchedule: 'Enregistrer',
    scheduleSaveFailed:
      'Échec de la mise à jour de l’horaire de réinitialisation',
    manualResetEnabled: 'Le statut des chambres sera réinitialisé manuellement',
    dailyResetAt:
      'Le statut des chambres sera réinitialisé chaque jour à {{time}}',
  },
} satisfies HotelsLocale
